module.exports = __webpack_public_path__ + "static/media/education.caed892b.caed892b.svg";